import { useMutation, useQuery } from "@tanstack/react-query"
import instance from "../instance"



interface IChat{
    message:string
    api_key?:string
}
interface IChatResponse{
    message:string,

}

export const useChat=()=>{

const chat=async(payload:IChat):Promise<IChatResponse>=>{
   const {data}= await instance.post('/answers/get-answer-with-context', { "top_k": 7,
    "api_key":payload.api_key||"99472f4d-bf99-4804-8455-36a515979678", query: payload.message })
 return data
}
const mutation = useMutation({
    mutationFn: chat,
})
return mutation
}

interface CategoryResponse{

    user_id: number;
    id: number;
    category_name: string;
    created_at: string;
    document_id: string;
  
}
export const useFetchCategories=(userID:string|number)=>{
    const fetchCategories = async():Promise<CategoryResponse[]>=>{
        const {data}= await instance.get(  `/category/get/${userID}`)
        return data
    }
    const query = useQuery({
        queryFn: fetchCategories,
        queryKey: ['categories', userID],
    })
return query
}

interface FAQResponse{
answer:string,
text:string
id:number

}
export const useFetchFAQ=(ID:number)=>{
    const fetchFAQ = async():Promise<FAQResponse[]>=>{
        const {data}= await instance.get(  `/category/get-question/${ID}`)
        return data
    }
    const query = useQuery({
        queryFn: fetchFAQ,
        queryKey: ['faq', ID],
    })
return query
}

